'use client';
import React from 'react';

interface ResponsiveSpacingProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'xl';
}

const ResponsiveSpacing: React.FC<ResponsiveSpacingProps> = ({ 
  children, 
  className = '',
  padding = 'md'
}) => {
  const paddingClasses = {
    sm: 'py-4 sm:py-6',
    md: 'py-6 sm:py-8 lg:py-10',
    lg: 'py-8 sm:py-10 lg:py-12',
    xl: 'py-10 sm:py-12 lg:py-16'
  };

  return (
    <div data-component-id="src/components/common/ResponsiveSpacing.tsx:23:4" data-component-path="src/components/common/ResponsiveSpacing.tsx" data-component-line="23" data-component-file="ResponsiveSpacing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveSpacing; 